import { Component, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import * as firebase from 'firebase';

@Component({
  selector: 'app-componente-customscript',
  templateUrl: './componente-customscript.component.html',
  styleUrls: ['./componente-customscript.component.scss']
})
export class ComponenteCustomscriptComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  
  // jsonData = {
  //   name: 'John Doe',
  //   age: 30,
  //   city: 'New York'
  // };

  jsonData = {};


  filename = 'mydata.json';


  saveJson(){
    console.log("started")
    let result=[]
    //firebase.firestore().collection("ptws").where("fechasolicitud",">=","2020-10-01").where("fechasolicitud","<=","2020-12-31")
    firebase.firestore().collection("users")
    
    .get().then((docs)=>{
      docs.forEach((item)=>{
        console.log("empujando "+item.id)
        result.push(item.data())
      })
    })
    .catch((err)=>{
      console.log("ERROR:  "+err)
    }).then(()=>{
      this.jsonData=result;
    }).then(()=>{
      this.generaArchivo()
    })
  }


  generaArchivo() {
    console.log("Generando archivo")
    const jsonString = JSON.stringify(this.jsonData, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    saveAs(blob, this.filename);
  }

  arraydelocsCharapa=[
    "","",""


  ]

  customScript(){
    console.log("custom script")
    let processed=0;
    firebase.firestore().collection("ptws").where("pozoSeleccionado","==","Chanangue K").get().
      then((docs)=>{
        console.log("Docs size: "+docs.size)
       docs.forEach((item)=>{
        firebase.firestore().collection("ptws").doc(item.id).update({
          cuenca:"Chanangue"
        }).then(()=>{
          processed++;
          console.log(processed);
        })
       })
      })
  }



}
